/**
 * Plan Group — field-level effects.
 *
 * Migrated from: plan/plan-group-base.coffee
 *
 * Old validators → new effects:
 *   CopyCarrierPhone → CopyCarrierPhone
 *
 * Skipped:
 *   handle(dfd) init logic — no runtime init needed
 *   Plan_groupCardReadBaseView — React handles natively
 */
import { copyRelatedFields } from "@neu/libui";

// ─── CopyCarrierPhone ──────────────────────────────────────────────────────
// Old: DSLFx.Validators.CopyCarrierPhone
// Trigger field: carrier_id
// Fetches carrier record and copies phone/fax into form fields.
export const CopyCarrierPhone = copyRelatedFields("carrier", {
	phone: "carrier_phone",
	fax: "carrier_fax",
});
